import { BASE_URL_MAP } from "~/core/constants/constants";
import RestService from "~/core/services/rest.service";
import type { SuperAdministration } from "~/modules/superAdministration/models/SuperAdministration.interface";

export class SuperAdministrationService extends RestService {
  async getSuperAdministration(): Promise<SuperAdministration> {
    return this.$apiV2.get(this.getSuperAdministrationPath());
  }

  getSuperAdministrationPath() {
    return BASE_URL_MAP.SUPER_ADMINISTRATION;
  }
}
export default new SuperAdministrationService();
